import { createMenu } from './menu';
import routes from './routes';
import { AbacoWebModule, MenuItem, RouterReadyEvent } from '@abaco/web-common/src/app';
import FarmerRegistryModule from '@abaco/farm-registry/src/modules/farm-registry';

export const MODULE_ID = "navigation_gis_module";

export default class NavigationGisModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    readonly id = MODULE_ID;
    readonly routes = routes;
    menu: MenuItem[] = [];
    public environment: string | null = null;

    dependsOn = {
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule()
    }

    constructor(environment: string) {
        this.environment = environment;
    }

    onRouterReady(evt: RouterReadyEvent) {
        this.menu = createMenu(evt.router);
    }
}
